import { render, staticRenderFns } from "./ReviewRecord.vue?vue&type=template&id=07f91031&scoped=true"
import script from "./ReviewRecord.vue?vue&type=script&lang=js"
export * from "./ReviewRecord.vue?vue&type=script&lang=js"
import style0 from "./ReviewRecord.vue?vue&type=style&index=0&id=07f91031&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f91031",
  null
  
)

export default component.exports